import { render, staticRenderFns } from "./LoginMovil.vue?vue&type=template&id=6cfc5cf0&scoped=true"
import script from "./LoginMovil.vue?vue&type=script&lang=js"
export * from "./LoginMovil.vue?vue&type=script&lang=js"
import style0 from "./LoginMovil.vue?vue&type=style&index=0&id=6cfc5cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc5cf0",
  null
  
)

export default component.exports